// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchContainer_Lywls {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
}
.searchInputWrapper_dsIkI {
  display: flex;
  align-items: center;
  background: var(--white-background);
  height: 30px;
  min-height: 30px;
  border: 1px solid var(--d9d9e3-border);
  border-radius: 8px;
  padding: 0px 8px 0px 2px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  width: 100%;
  gap: 4px;
  input{
    padding: 8px 0px !important;
    background-color: transparent !important;
  }
}

.searchIconsWrappers_BOTYg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.searchIcon_Q61q1 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--_6-color);
}

.searchInput_H9rk5 {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 13px;
  outline: none;
  color: var(--black-color);
}

.searchInput_H9rk5::placeholder {
  color: var(--_6-color);
}
.searchIconsWrappers_BOTYg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}


.imageHover_GKIPt {
  position: relative
}

.imageHover_GKIPt:hover {
  .shadowContainer_hPdKk {
    opacity: 1;
  }
}

.shadowContainer_hPdKk {
  background-color: var(--_52525261-background);
  transition: all 300ms;
  width: 25px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  position: absolute;
  top: 50%;
  border-radius: 4px;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  pointer-events: none;
}



.count_GcMv8{
  position: absolute;
  background-color: var(--_2-color);
  color: var(--white-background);
  padding: 2px 3px;
  border-radius: 6px;
  top: -2px;
  right: 0px;
  font-size: 7px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/SearchIconWithIcon/SearchIconWithIcon.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,QAAQ;EACR;IACE,2BAA2B;IAC3B,wCAAwC;EAC1C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,oBAAoB;AACtB;;;;AAIA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;AAChB","sourcesContent":[".searchContainer {\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  align-items: center;\n}\n.searchInputWrapper {\n  display: flex;\n  align-items: center;\n  background: var(--white-background);\n  height: 30px;\n  min-height: 30px;\n  border: 1px solid var(--d9d9e3-border);\n  border-radius: 8px;\n  padding: 0px 8px 0px 2px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  width: 100%;\n  gap: 4px;\n  input{\n    padding: 8px 0px !important;\n    background-color: transparent !important;\n  }\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.searchIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: var(--_6-color);\n}\n\n.searchInput {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  outline: none;\n  color: var(--black-color);\n}\n\n.searchInput::placeholder {\n  color: var(--_6-color);\n}\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n\n.imageHover {\n  position: relative\n}\n\n.imageHover:hover {\n  .shadowContainer {\n    opacity: 1;\n  }\n}\n\n.shadowContainer {\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  width: 25px;\n  height: 27px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 300ms;\n  position: absolute;\n  top: 50%;\n  border-radius: 4px;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n  pointer-events: none;\n}\n\n\n\n.count{\n  position: absolute;\n  background-color: var(--_2-color);\n  color: var(--white-background);\n  padding: 2px 3px;\n  border-radius: 6px;\n  top: -2px;\n  right: 0px;\n  font-size: 7px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchContainer": `searchContainer_Lywls`,
	"searchInputWrapper": `searchInputWrapper_dsIkI`,
	"searchIconsWrappers": `searchIconsWrappers_BOTYg`,
	"searchIcon": `searchIcon_Q61q1`,
	"searchInput": `searchInput_H9rk5`,
	"imageHover": `imageHover_GKIPt`,
	"shadowContainer": `shadowContainer_hPdKk`,
	"count": `count_GcMv8`
};
export default ___CSS_LOADER_EXPORT___;
